import { useEffect, useMemo } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Container } from "react-bootstrap";

import { getTerminal } from "../../redux/slices/TerminalListSlice";

import HeaderWhite from "../Header/HeaderWhite";
import FirstBlock from "./FirstBlock";
import SecondBlock from "./SecondBlock";

import styles from "./InfrastructureBlock.module.scss";

const InfrastructureBlock = () => {
  const dispatch = useDispatch();

  const terminalList = useSelector(
    (state) => state.terminalList?.terminalList ?? [],
    shallowEqual
  );

  useEffect(() => {
    dispatch(getTerminal());
  }, [dispatch]);

  const sortedTerminal = useMemo(() => {
    return [...terminalList].sort((a, b) => (a?.id ?? 0) - (b?.id ?? 0));
  }, [terminalList]);

  return (
    <div className={styles.root}>
      <Container>
        <HeaderWhite />
        <FirstBlock />
        {sortedTerminal.map((n) => (
          <SecondBlock {...n} key={n?.id ?? Math.random()} />
        ))}
      </Container>
    </div>
  );
};

export default InfrastructureBlock;
